import * as React from 'react';

import { ContractInvitationsProps } from 'features/contract/containers/ContractInvitationsContainer';
import { PendingInvitationsList } from 'features/invite/components/PendingInvitationsList';

export const ContractInvitations: React.FunctionComponent<ContractInvitationsProps> = (props) => (
    <PendingInvitationsList {...props} />
);
